export default "__VITE_ASSET__BubNzReM__"